import FormError from "components/FormError"
import FormLabel from "components/FormLabel"
import { FormHelperText } from "components/FormHelperText"
import React from "react"
import { Controller, useController, useFormContext } from "react-hook-form"
import { useValidationContext } from "app/components/Form/ValidationContext/ValidationContext"
import { IFormControllerProps } from "./types"
import { isFieldRequired } from "./utils"

export function FormController({
  label,
  name,
  required = false,
  disabled,
  extraHelperText,
  inputRender,
  onChange,
  onFocus,
  onBlur,
  isFocused,
}: IFormControllerProps) {
  const { control, formState: { errors } } = useFormContext()
  const { schema } = useValidationContext()
  const isRequired = schema ? isFieldRequired(schema, name) : required

  const {
    fieldState: { invalid },
  } = useController({
    name,
    control,
  })
  const error = errors[name]

  return (
    <>
      <FormLabel
        isFocused={isFocused}
        name={name}
        label={label}
        required={isRequired}
        invalid={invalid}
        disabled={disabled}
      />
      <Controller
        name={name}
        control={control}
        render={({ field: { ref: _, onChange: onControllerChange, ...restProps }, fieldState }) =>
          inputRender({
            ...restProps,
            onChange: (event, child) => {
              onControllerChange(event, child)
              onChange?.(event)
            },
            onFocus,
            onBlur,
            error: fieldState.invalid,
          })
        }
      />
      {error ? (
        <FormError error={error as any} />
      ) : (
        <FormHelperText disabled={disabled} extraHelperText={extraHelperText} label={label} />
      )}
    </>
  )
}
